import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'

export const getRewards = async (instance: AxiosInstance) => {
  return await userApiDefaultApiFactory(instance).getRewards()
}

// Do Not Remove this line ===@import api client===
